/** 全站通用按钮与短文案（页面标题等仍放在 pages.ts） */
export default {
  'pages.common.save': '保存',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '确定',
  'pages.common.ok': '确定',
  'pages.common.delete': '删除',
  'pages.common.edit': '编辑',
  'pages.common.add': '新增',
  'pages.common.append': '添加',
  'pages.common.search': '查询',
  'pages.common.reset': '重置',
  'pages.common.submit': '提交',
  'pages.common.back': '返回',
  'pages.common.close': '关闭',
  'pages.common.export': '导出',
  'pages.common.import': '导入',
  'pages.common.refresh': '刷新',
  'pages.common.detail': '详情',
  'pages.common.copy': '复制',
  'pages.common.operation': '操作',
  'pages.common.view': '查看',
  'pages.common.download': '下载',
  'pages.common.upload': '上传',
  'pages.common.yes': '是',
  'pages.common.no': '否',
  'pages.common.loading': '加载中…',
  'pages.common.more': '更多',
  'pages.common.all': '全部',
  'pages.common.createSuccess': '新增成功',
  'pages.common.saveSuccess': '保存成功',
  'pages.common.deleteSuccess': '删除成功',
  'pages.common.deleteFailed': '删除失败',
  'pages.common.saveFailed': '保存失败',
  'pages.common.loadFailed': '加载失败',
  'pages.common.requiredField': '此项为必填项',
  'pages.common.selectedCount': '已选择 {count} 项',
  'pages.common.clearSelection': '取消选择',
  'pages.common.totalRecords': '共 {total} 条记录',
  'pages.common.batchDeleteCount': '批量删除 ({count})',
  'pages.common.statusSuccess': '成功',
  'pages.common.statusFailed': '失败',
  'pages.common.timeRangeStart': '开始时间',
  'pages.common.timeRangeEnd': '结束时间',
  'pages.common.unnamed': '未命名',
  'pages.common.operationFailedRetry': '操作失败，请重试',
  'pages.common.batchDeleteSuccess': '批量删除成功',
  'pages.common.batchDeleteFailed': '批量删除失败，请重试',
  'pages.common.nItemsFailed': '{count} 项失败',
  'pages.common.enable': '启用',
  'pages.common.disable': '禁用',
  'pages.common.statusNormal': '正常',
  'pages.common.statusDisabled': '禁用',
  'pages.common.selectOrganization': '请选择机构',
  'pages.common.batchDeleteTitle': '确认批量删除',
  'pages.common.downloadingTemplate': '正在下载模版…',
  'pages.common.templateDownloadSuccess': '模版下载成功',
  'pages.common.templateDownloadFailed': '模版下载失败，请稍后重试',
};
